export default {
  UPDATE_ACTIVATE_ACCT_BTN_CLICKED: "[activateAcctBtnClicked] Update Activate Account Button Clicked",
  RESET_ACTIVATE_ACCT_BTN_CLICKED: "[activateAcctBtnClicked] Reset Activate Account Button Clicked",
};
